import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useVenti } from 'venti'
import Page from '../../../components/Page'
import { Footer } from '../../../components/Footer'
import { useAppContext } from '../../../components/AppContext'
import { getTheme } from '../../../config'
import ModalAppError from '../../../components/modals/ModalAppError'
import ModalTutorial from '../../../components/modals/ModalTutorial'
import { navigationLinking } from '../../../services/navigation'
import ModalNewUser from '../../../components/modals/ModalNewUser'
import ModalWorkflowSelector from '../../../components/modals/ModalWorkflowSelector'
import PortalActionCards from '../../../components/portal/PortalActionCards'
import PortalHeader from '../../../components/portal/PortalHeader'
import ModalInviteBorrower from '../../../components/modals/ModalInviteBorrower'
import ModalLoanDraft from '../../../components/modals/ModalLoanDraft'
import ModalEConsent from '../../../components/modals/ModalEConsent'
import { AppContextState } from '../../../types'
import ModalAppPosting from '../../../components/modals/ModalAppPosting'

const theme = getTheme()

export default function Portal() {
	const navigate = useNavigate()
	const ventiState = useVenti()
	const { state } = useAppContext()
	const { siteConfig, socialLinks, legalLinks, user } =
		state as unknown as AppContextState

	const appSubmitted = ventiState.get(theme.storageKeys.appSubmitted)

	const failoverModalVisible = ventiState.get(
		theme.storageKeys.failoverModalVisible
	)

	useEffect(() => {
		if (!user?.isLoggedIn) {
			navigate(`/${navigationLinking.SignIn}`)
		}
	}, [user?.isLoggedIn, navigate])

	return (
		<>
			<Page page="app-portal" title="Portal" isFullWidth>
				<PortalHeader />
				<PortalActionCards />
				<hr className="border-b-2" />
				<Footer
					siteConfig={siteConfig || undefined}
					socialLinks={socialLinks}
					legalLinks={legalLinks}
				/>
			</Page>

			<ModalAppPosting />

			<ModalInviteBorrower />

			<ModalLoanDraft />

			<ModalEConsent />

			<ModalWorkflowSelector />

			<ModalTutorial />

			<ModalNewUser />

			<ModalAppError
				visible={!appSubmitted && failoverModalVisible}
				siteConfig={siteConfig}
			/>
		</>
	)
}
